import { useEffect, useRef } from "react";
import { usePage } from "@inertiajs/react";
import { toast } from "@/hooks/use-toast";

type FlashProps = {
  flash?: {
    alert?: string;
    notice?: string;
  };
};

let lastToastKey: string | null = null;
let lastToastAt = 0;

export const FlashToastBridge = () => {
  const { props } = usePage<FlashProps>();
  const lastMessageRef = useRef<string | null>(null);
  const alert = props.flash?.alert;
  const notice = props.flash?.notice;

  useEffect(() => {
    const message = alert ?? notice;
    if (!message || lastMessageRef.current === message) return;

    const key = `${alert ? "alert" : "notice"}:${message}`;
    const now = Date.now();
    if (lastToastKey === key && now - lastToastAt < 1500) return;

    lastMessageRef.current = message;
    lastToastKey = key;
    lastToastAt = now;
    toast({
      title: alert ? "エラー" : "完了",
      description: message,
      variant: alert ? "destructive" : "default",
    });
  }, [alert, notice]);

  return null;
};
